import { ListHeaderCellType } from 'views/components/atoms/listCell';
import { ListHeaderType } from 'views/components/molecules/listHeader';

export function getAccountTransactionHistoryHeaderShowList(): ListHeaderType[] {
  return [
    {
      type: ListHeaderCellType.textCell,
      label: '入出金日',
    },
    {
      type: ListHeaderCellType.sentenceCell,
      label: '摘要',
    },
    {
      type: ListHeaderCellType.textCell,
      label: '入金',
    },
    {
      type: ListHeaderCellType.textCell,
      label: '出金',
    },
    {
      type: ListHeaderCellType.textCell,
      label: '振替',
    },
  ];
}
